
import styled from "styled-components";

export const CheckboxInputBox = styled.input.attrs({
    type: "checkbox",
})`
    -webkit-appearance: none;
    appearance: none;
    background-color: ${({theme}) => theme.colors.backgroundDark};
    width: 1.65em;
    height: 1.65em;
    border: 1px solid ${({theme}) => theme.colors.boxBorderLighter};
    border-radius: 20%;

    display: grid;
    place-content: center;
    &:before{
        content: "";
        width: 0.65em;
        height: 0.65em;
        border-radius: 20%;
        transform: scale(0);
        background-color: ${({theme}) => theme.colors.brandPrimary};;
    }

    &:checked{
        &:before{
            transform: scale(1);
        }
    }
`;